import React from 'react';
import BuildControl from './BuildControl//BuildControl';
import classes from './BuildControls.css';

const controls=[
    {label:'Salad',type:'salad'},
    {label:'Meat',type:'meat'},
    {label:'Bacon',type:'bacon'},
    {label:'Cheese',type:'cheese'}
];
const buildControls= (props)=>(
    <div className={classes.BuildControls}>
        {controls.map((ctrl)=>(
            <BuildControl 
                added={()=>props.ingredientAdded(ctrl.type)} 
                removed={()=>props.ingredientRemoved(ctrl.type)}
                disable={props.disabled[ctrl.type]}
                key={ctrl.label} 
                label={ctrl.label} 
                type={ctrl.type} />
        ))}
        <button 
            className={classes.OrderButton} 
            disabled={!props.purchaseable} 
            onClick={props.purchasing} >{props.isAuthenticated?'ORDER NOW':'SIGN UP TO ORDER'}</button>
    </div>
)

export default buildControls;
